import { TextField } from '@mui/material';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { Controller } from 'react-hook-form';
import { PatternFormat } from 'react-number-format';

/**
 * @description Renders a cnpj field wrapped in a Controller component.
 *
 * @author Maria Eduarda Franke
 * @param {string} props.name - The name of the input field.
 * @param {string} props.label - The label for the input field.
 * @param {Object} props.control - The control object from react-hook-form.
 * @param {Object} props.errors - The errors object from react-hook-form.
 * @returns {JSX.Element} - The rendered password input field.
 */
const FormInputCnpj = forwardRef(({ name, label, control, errors, ...props }, ref) => {

    return (
        <Controller
            control={control}
            name={name}
            render={({ field }) => (
                <PatternFormat
                    {...field}
                    ref={ref}
                    format='##.###.###/####-##'
                    allowEmptyFormatting
                    mask='_'
                    variant='outlined'
                    customInput={TextField}
                    label={label}
                    error={!!errors}
                    helperText={errors?.message}
                    {...props}
                />
            )}
        />
    )
})

FormInputCnpj.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    control: PropTypes.object,
    errors: PropTypes.object
}

FormInputCnpj.displayName = 'FormInputCnpj'

export default FormInputCnpj